import * as restErrorHandler from "@sharedJS/restErrorHandler";
import * as rest from "@sharedJS/rest";
import commonPopup from "@JS/shop/10-login-component/commonPopup";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

let googleAuthenticateBtn;
let $loginForm;
let auth2;
let isSubscribed = false;

const loginFormId = "#google-login-form";

function init() {
	if (!isSubscribed) {
		OcmMessenger.subscribe(messengerPublicationTypes.REQUEST_LOGIN, init);
		isSubscribed = true;
	}

	// DOM
	googleAuthenticateBtn = document.getElementById("loginGoogleBtn");
	$loginForm = $("#google-login-form");

	if (!googleAuthenticateBtn) {
		return;
	}

	if (_isApp()) {
		$("#loginGoogleBtn").hide();
		return;
	}

	attachSignin();
}

async function initGoogleAuth() {
	if (auth2) return;

	if (!window.gapi) {
		await $.getScript("https://apis.google.com/js/api:client.js");
	}
	if (!window.gapi.auth2) {
		await new Promise((resolve) => window.gapi.load("auth2", resolve));
	}
	auth2 = window.gapi.auth2.init({
		client_id: ocm.config.googleClientId,
		cookie_policy: ocm.config.googleCookiePolicy,
	});
}

async function attachSignin() {
	if (googleAuthenticateBtn.classList.contains("js-login-google-attached")) {
		return;
	}

	await initGoogleAuth();
	auth2.attachClickHandler(
		googleAuthenticateBtn,
		{},
		(googleUser) => {
			authenticateWithGoogleAction(googleUser);
		},
		(error) => {
			console.error(JSON.stringify(error, undefined, 2));
		}
	);
	googleAuthenticateBtn.classList.add("js-login-google-attached");
}

function authenticateWithGoogleAction(googleUser) {
	const googleData = _createGoogleData(
		googleUser.getAuthResponse().id_token,
		googleAuthenticateBtn.getAttribute("googleAction"),
		googleAuthenticateBtn.getAttribute("isRememberMe")
	);
	_doServerAuthentication(googleData);
}

function _doServerAuthentication(googleData) {
	_googleServerRequest(googleData);
}

function _createGoogleData(accessToken, action, rememberMe) {
	return {
		serverUrl: action,
		tokenId: accessToken,
		formId: loginFormId,
		rememberMe,
	};
}

function _googleServerRequest(googleData) {
	removeErrors();

	const postActionExists = $("#master-common-layer").attr("data-postActionJs");
	let dataType = "json";

	if (postActionExists) {
		dataType = "html";
	}
	$.ajax({
		url: googleData.serverUrl,
		dataType,
		type: "POST",
		data: googleData,
	})
		.done((responseData) => {
			if (postActionExists) {
				commonPopup.closeLayer();
				commonPopup.doStartPopupPostAction(responseData);
			} else {
				rest.handleRedirect(
					{ responseJSON: { redirectUrl: responseData.redirectUrl } },
					{ saveRedirectToHistory: false }
				);
			}
		})
		.fail(async (responseData) => {
			await initGoogleAuth();
			auth2.signOut().then(() => {
				console.log(`User signed out.`);
			});
			restErrorHandler.handleError(responseData, googleData.formId, _googleServerRequest, googleData);
			OcmMessenger.publish(messengerPublicationTypes.GOOGLE_LOGIN, {
				type: "ERROR",
				detail: responseData.responseJSON.globalErrorMessages,
			});
		});
}

//--------------------------
// Helper
//--------------------------
function removeErrors() {
	$loginForm.empty();
}

function _isApp() {
	// Facebook / Instagramm
	const ua = navigator.userAgent || navigator.vendor || window.opera;
	return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1 || ua.indexOf("Instagram") > -1;
}

export { init, authenticateWithGoogleAction };
